<template>
  <div class="container">
    <pdf :src="pdfUrl"></pdf>
  </div>
</template>

<script>
  import pdf from 'vue-pdf'
  export default {
    data(){
      return{
        pdfUrl:''
      }
    },
    components: {
        pdf
    },
    methods:{},
    created(){},
    mounted(){
        this.pdfUrl = this.$route.query.url
    }
 }
</script>

<style scoped>
  .container {
    width: 100%;
    height: 500px;
  }
</style>